import { generateResponse, getStoredHistory } from "./askpurpleEngine";

export const chatService = {
  /**
   * Send a message to AskPurple AI assistant.
   * Runs natively via client-side intelligence engine (zero backend dependency).
   * @param {Object} params
   * @param {string|null} params.sessionId
   * @param {string} params.message
   * @param {string} [params.contextVertical="general"]
   * @param {Object} [params.profile]
   */
  async sendMessage({ sessionId, message, contextVertical = "general", profile }) {
    await new Promise((r) => setTimeout(r, 350));
    return generateResponse({
      sessionId,
      message,
      contextVertical,
      profile,
    });
  },

  /**
   * Fetch conversation message history for a given session.
   * @param {string} sessionId
   */
  async getHistory(sessionId) {
    return getStoredHistory(sessionId);
  },
};

export default chatService;
